import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTable, MatTableDataSource, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-view-client-services-modal',
    standalone: true,
    templateUrl: './view-client-services-modal.component.html',
    styleUrls: ['./view-client-services-modal.component.scss'],
    imports: [
      MatDialogModule,
      MatButtonModule,
      MatIcon,
      MatTable,
      MatColumnDef,
      MatHeaderCellDef,
      MatHeaderCell,
      MatCellDef,
      MatCell,
      MatHeaderRowDef,
      MatHeaderRow,
      MatRowDef,
      MatRow]
})
export class ViewClientServicesModalComponent {
  dialogRef = inject<MatDialogRef<ViewClientServicesModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['name', 'alias'];
  clientCode: string;

  constructor() {
    const data = this.data;

    this.clientCode = data.selectedClient.code;
    const serviceList = data.serviceList;
    this.dataSource.data = Object.keys(data.selectedClient.services || {}).map(key => {
      return {
        name: serviceList.find((svc: any) => svc.primaryKeyPart === key).name,
        alias: data.selectedClient.services[key]
      };
    })
  }
}
